// src/push.js
import { api } from "./api";

const VAPID_PUBLIC_KEY = process.env.REACT_APP_VAPID_PUBLIC_KEY;

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) outputArray[i] = rawData.charCodeAt(i);
  return outputArray;
}

async function getReg() {
  if (!("serviceWorker" in navigator)) throw new Error("No service worker support");
  return navigator.serviceWorker.register("/sw.js", { scope: "/" });
}

export async function initAdminPush() {
  if (!VAPID_PUBLIC_KEY) throw new Error("Missing REACT_APP_VAPID_PUBLIC_KEY");
  if (!("PushManager" in window)) throw new Error("No Push support");

  const reg = await getReg();
    if (!navigator.serviceWorker.controller) {
    // iOS sometimes needs a reload after first SW install to become controlled
    // Don't throw; but tell the UI to reload (or auto reload once).
    console.warn("[push] No SW controller yet. Reload the app once.");
  }

  const perm = await Notification.requestPermission();
  if (perm !== "granted") throw new Error("Permission denied");

  let sub = await reg.pushManager.getSubscription();

  if (!sub) {
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY),
    });
  }

  await api.pushSubscribe(sub.toJSON());
  return sub;
}

export async function disableAdminPush() {
  const reg = await getReg();
  const sub = await reg.pushManager.getSubscription();
  if (!sub) return;

  const endpoint = sub.endpoint;
  await sub.unsubscribe().catch(() => {});
  await api.pushUnsubscribe(endpoint);
}